/**
 * Remove the login account that was just created when the profile behind it
 * could not be written.
 *
 * Registration happens in two steps that do not succeed or fail together: first
 * the Firebase auth account, then the Cloud Function that writes the profile and
 * the tenant membership. If the second step fails, what is left behind is worse
 * than nothing — the person can sign in, the app has no idea who they are, and a
 * second attempt is refused with `auth/email-already-in-use`. That is exactly
 * how FIXbrigade Amersfoort ended up locked out (docs/inbox.md Bug #137).
 *
 * A failure to clean up stays visible in the console rather than throwing: the
 * caller still needs to surface the original registration error, which is the
 * more useful one. Someone in that state needs help from Deccos.
 *
 * AI-CONTEXT: See docs/pitfalls.md#state-multi-step-signup-leaves-half-an-account
 *
 * @param {{delete?: () => Promise<void>} | undefined} user - The account created moments ago
 * @returns {Promise<void>} Always resolves
 */
const removeHalfCreatedAccount = async (user) => {
    try {
        await user.delete()
    } catch (deleteError) {
        console.error('Kon het half aangemaakte account niet verwijderen', deleteError)
    }
}

export default removeHalfCreatedAccount
